<template>
  <div>
    <basic-container>
      <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
        @search-change="searchChange" @refresh-change="refreshChange(page)" @search-reset="searchClear"
        @selection-change="handleSelectionChange" @size-change="pageSizeChange" @current-change="pageChange">
        <template slot="menuLeft">
          <el-button type="text" size="small" icon="el-icon-plus" plain @click.stop="handleAdd">新增</el-button>
          <el-button type="text" icon="el-icon-delete" size="small" plain
            v-if="permission.JOINS_SALES_CLOUD_WORK_PROJECTDYNAMIC"
            @click.stop="handleDel('DELETE_OPTION', '逻辑删除')">删除</el-button>
          <el-button type="text" icon="el-icon-delete" size="small" plain
            v-if="permission.JOINS_SALES_CLOUD_WORK_PROJECTDYNAMIC"
            @click.stop="handleDel('DELETE_OPTION', '物理删除')">物理删除</el-button>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button type="text" size="small" icon="el-icon-edit" plain
            @click.stop="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" size="small" icon="el-icon-view" plain
            @click.stop="handleView(scope.row)">查看</el-button>
        </template>
      </avue-crud>
    </basic-container>

    <!-- 新增弹窗 -->
    <el-dialog title="新增防水动态表单" :visible.sync="addDialogVisible" fullscreen append-to-body
      :close-on-click-modal="false">
      <AddForm :visible="addDialogVisible" @close="handleAddClose" @submit-success="handleAddSuccess" />
    </el-dialog>

    <!-- 编辑弹窗 -->
    <el-dialog title="编辑防水动态表单" :visible.sync="editDialogVisible" fullscreen append-to-body
      :close-on-click-modal="false">
      <EditForm :visible="editDialogVisible" :project-id="editProjectId" :agent-id="editAgentId"
        @close="handleEditClose" @submit-success="handleEditSuccess" />
    </el-dialog>

    <!-- 查看弹窗 -->
    <el-dialog title="查看防水动态表单" :visible.sync="viewDialogVisible" fullscreen append-to-body
      :close-on-click-modal="false">
      <ViewForm :visible="viewDialogVisible" :project-id="viewProjectId" :agent-id="viewAgentId"
        @close="handleViewClose" />
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { findByLabel } from "@/util/util";
import { DIC } from "@/const/dic";
import { projectDynamicOption } from "@/const/work/waterProof/projectDynamicOption";
import {
  findWaterProofDynamic,
  delProject,
} from "@/api/work/waterProof/projectDynamic";
import AddForm from './add.vue';
import EditForm from './edit.vue';
import ViewForm from './view.vue';

export default {
  name: "manageProject",
  components: {
    AddForm,
    EditForm,
    ViewForm
  },
  data() {
    return {
      tableOption: projectDynamicOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      loading: false,
      classifySelects: [],
      currClassify: [],
      tabelObj: {},
      ids: "",
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10, //每页显示多少条
      },
      grade: {
        box: false,
        check: [],
      },
      // 弹窗相关状态
      addDialogVisible: false,
      editDialogVisible: false,
      viewDialogVisible: false,
      editProjectId: '',
      editAgentId: '',
      viewProjectId: '',
      viewAgentId: ''
    };
  },
  created() {
    this.handleList();
  },
  watch: {},
  mounted() { },
  computed: {
    ...mapGetters(["permission"]),
  },
  props: [],
  methods: {
    clean() {
      this.currClassify = "";
      this.classifySelects = [];
    },
    searchClear() {
      this.currClassify = "";
    },
    choseClassifyItem() {
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = this.page.currentPage;
      params.size = pageSize;
      params.type = "WATERPROOF_PROJECT";
      this.downloadData = params;
      findWaterProofDynamic(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize,
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      params.type = "WATERPROOF_PROJECT";
      this.downloadData = params;
      findWaterProofDynamic(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      params.type = "WATERPROOF_PROJECT";
      findWaterProofDynamic(params).then((res) => {
        if (res.code != 500) {
          let data = JSON.parse(res.data);
          this.tableData = data.rows;
          this.page = {
            total: data.total,
            currentPage: params.page,
            pageSize: params.size,
          };
          this.tableLoading = false;
        } else {
          this.tableLoading = false;
          this.tableData = [];
        }
      });
    },
    //eslint-disable-next-line
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      params.type = "WATERPROOF_PROJECT";
      this.downloadData = params;
      findWaterProofDynamic(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 打开新增窗口
     */
    handleAdd() {
      this.addDialogVisible = true;
    },

    /**
     * @title 关闭新增窗口回调
     */
    handleAddClose() {
      this.addDialogVisible = false;
    },

    /**
     * @title 新增成功回调
     */
    handleAddSuccess() {
      this.addDialogVisible = false;
      this.handleList(); // 刷新列表数据
    },

    /**
     * @title 打开编辑窗口
     */
    handleEdit(row) {
      this.editProjectId = row.id;
      this.editAgentId = row.agentId;
      this.editDialogVisible = true;
    },

    /**
     * @title 关闭编辑窗口回调
     */
    handleEditClose() {
      this.editDialogVisible = false;
    },

    /**
     * @title 编辑成功回调
     */
    handleEditSuccess() {
      this.editDialogVisible = false;
      this.handleList(); // 刷新列表数据
    },

    /**
     * @title 打开查看窗口
     */
    handleView(row) {
      this.viewProjectId = row.id;
      this.viewAgentId = row.agentId;
      this.viewDialogVisible = true;
    },

    /**
     * @title 关闭查看窗口回调
     */
    handleViewClose() {
      this.viewDialogVisible = false;
    },

    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let params = {
        page: this.page.currentPage,
        size: this.page.pageSize,
        type: "WATERPROOF_PROJECT",
      };
      this.downloadData = params;
      findWaterProofDynamic(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange(val) {
      let ids = val.map((item) => {
        return item.id;
      });
      this.ids = ids.join(",");
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(dicName, label) {
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error",
        });
        return;
      }

      this.$confirm(`是否确认删除?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id);
          }

          delProject(findByLabel(DIC.DELETE_OPTION, label), ids)
            .then((response) => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "删除成功",
                  type: "success",
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error",
              });
            });
        })
        .catch(() => { });
    },

  },
};
</script>

<style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
